import * as d3 from 'd3';
import { GAS_LIMIT, BLOCK_INFOS_API, BUILDER_UNKNOWN, BLOCK_GAS_MOD } from '../utils/constants.js';

function transactionLink(txhash) {
    return "https://etherscan.io/tx/" + txhash
}

function shortAddress(address) {
    if (address.length >= 10) {
        var firstFive = address.slice(0, 5);
        var lastFive = address.slice(-5);
        return firstFive + "..." + lastFive;
    } else {
        return address
    }
}

function getFormattedDate(timestampSeconds) {
    var timestampMilliseconds = timestampSeconds * 1000;
    var date = new Date(timestampMilliseconds);

    var year = date.getUTCFullYear();
    var month = String(date.getUTCMonth() + 1).padStart(2, '0');
    var day = String(date.getUTCDate()).padStart(2, '0');
    var hours = String(date.getUTCHours()).padStart(2, '0');
    var minutes = String(date.getUTCMinutes()).padStart(2, '0');
    var seconds = String(date.getUTCSeconds()).padStart(2, '0');

    var formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC';

    return formattedDate;
}

export default class BlockHistoryUI {

    constructor(block_history_candles_div, block_history_blocks_div, block_table_ui) {
        this.block_table_ui = block_table_ui
        this.padding = { top: 15, right: 30, bottom: 25, left: 30 };
        this.format4 = d3.format('.4f');
        this.format2 = d3.format('.2f');

        var parentDivCandles = document.querySelector(block_history_candles_div);
        var rectCandles = parentDivCandles.getBoundingClientRect();
        this.heightCandlesDiv = rectCandles.height;
        this.widthCandlesDiv = rectCandles.width;

        var parentDivBlocks = document.querySelector(block_history_blocks_div);
        var rectBlocks = parentDivBlocks.getBoundingClientRect();
        this.heightBlocksDiv = rectBlocks.height;
        this.widthBlocksDiv = rectBlocks.width;

        this.setupCandlesGraph(block_history_candles_div)
        this.setupBlocksGraph(block_history_blocks_div)
        // setup tooltips
        this.setupCandlesToolTip(block_history_candles_div)
        this.setupBlocksToolTip(block_history_blocks_div)
        // append trigger
        this.disable_append = false
        // use mock data
        //this.drawBlockCandles(generateBlockCandles())
        //this.drawBlockInfos(generateBlockInfos())
    }

    newBlockCandle = (block_candle) => {
        console.log(block_candle)
    }

    newBlockInfo = (block_info) => {
        if (!this.disable_append) {
            // TODO: check if block candle was clicked, if yes then do not add
            this.block_infos.push(block_info)
            if (this.block_infos.length > 1) {
                this.block_infos.shift();
            }
            this.drawBlockInfos(this.block_infos)
        }
    }

    setBlockCandles = (block_candles) => {
        this.drawBlockCandles(block_candles)
    }

    setBlockInfos = (block_infos) => {
        this.block_infos = block_infos
        this.drawBlockInfos(block_infos)
    }

    setupCandlesGraph = (block_history_candles_div) => {

        this.svgCandles = d3.select(block_history_candles_div).append("svg")
            .attr("width", this.widthCandlesDiv)
            .attr("height", this.heightCandlesDiv)

        this.xCandlesValue = d3.scaleBand()
            .range([this.padding.left + 1, this.widthBlocksDiv - this.padding.right])

        this.xCandlesGas = d3.scaleLinear()
            .range([this.padding.left, this.widthCandlesDiv - this.padding.right])

        this.yCandlesValue = d3.scaleLinear()
            .domain([0, 1])
            .range([this.heightCandlesDiv - this.padding.bottom, this.padding.top]);

        this.yCandlesGas = d3.scaleLinear()
            .domain([1, 50])
            .range([this.heightCandlesDiv - this.padding.bottom, this.padding.top]);

        this.xaxisCandles = this.svgCandles.append("g")
            .attr("transform", `translate(0, ${this.heightCandlesDiv - this.padding.bottom})`)
            .call(d3.axisBottom(this.xCandlesValue).ticks(5));

        this.yaxisCandlesValue = this.svgCandles.append("g")
            .attr("transform", `translate(${this.padding.left}, 0)`)
            .call(d3.axisLeft(this.yCandlesValue).ticks(1));

        this.yaxisCandlesGas = this.svgCandles.append("g")
            .attr("transform", `translate(${this.widthCandlesDiv - this.padding.right}, 0)`)
            .call(d3.axisRight(this.yCandlesGas).ticks(1));

        // Y label
        this.ylabelCandlesLeft = this.svgCandles.append('text')
            .attr('text-anchor', 'middle')
            .attr('transform', 'translate(10,' + (this.heightCandlesDiv - this.padding.bottom + this.padding.top) / 2 + ')rotate(-90)')
            .style('font-family', 'Courier,Courier New,slab-serif')
            .style('font-size', 12)
            .style("font-weight", "bold")
            .style('fill', '#d3d3d3')
            .text('Value');

        this.ylabelCandlesRight = this.svgCandles.append('text')
            .attr('text-anchor', 'middle')
            .attr('transform', `translate(${this.widthCandlesDiv}, ${(this.heightCandlesDiv - this.padding.bottom + this.padding.top) / 2}) rotate(-90)`)
            .style('font-family', 'Courier, Courier New, slab-serif')
            .style('font-size', 12)
            .style('font-weight', 'bold')
            .style('fill', '#d3d3d3')
            .text('Fee');

        const axisLineStyle = window.getComputedStyle(this.yaxisCandlesValue.select(".domain").node());

        this.hlineCandles = this.svgCandles.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthCandlesDiv - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.padding.top)
            .style("stroke-width", axisLineStyle.getPropertyValue("stroke-width"))
            .style("stroke", axisLineStyle.getPropertyValue("stroke"));

    }

    setupCandlesToolTip = (block_history_candles_div) => {
        // Add a tooltip div. Here I define the general feature of the tooltip: stuff that do not depend on the data point.
        // Its opacity is set to 0: we don't see it by default.
        this.tooltipCandles = d3.select(block_history_candles_div)
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")

        // A function that change this tooltip when the user hover a point.
        // Its opacity is set to 1: we can now see it. Plus it set the text and position of tooltip depending on the datapoint (d)
        this.mouseoverCandles = (e, d) => {
            const barId = d3.select(e.target).attr("data-rect-id");
            const rects = d3.selectAll(".bar-group-candles")
                .selectAll("rect")
                .filter((_, gi) => gi === +barId);
            rects.classed("highlighted", true);

            this.tooltipCandles = this.tooltipCandles
                .style("opacity", 1)
        }

        this.mousemoveCandles = (e, candle) => {
            const [x, y] = d3.pointer(e);

            // Calculate the tooltip position relative to the mouse cursor
            const tooltipLeft = x + 10; // Add an offset to adjust the position
            const tooltipTop = y + 10; // Add an offset to adjust the position

            this.tooltipCandles = this.tooltipCandles
                .html(`
                <div class='tooltip-tx'>
                    <strong>Time: ${getFormattedDate(candle.from_timestamp)} - ${getFormattedDate(candle.to_timestamp)}</strong><br>
                    <strong>Block: ${candle.from_block} - ${candle.to_block}</strong><br><br>
                    <strong style="display: inline-block; width: 150px;">Maximum Payment:</strong> ${(candle.max_payment).toFixed(8)} ETH<br>
                    <strong style="display: inline-block; width: 150px;">Maximum Payout:</strong> ${(candle.max_payout).toFixed(8)} ETH<br>
                    <strong style="display: inline-block; width: 150px;">Maximum Base Fee:</strong> ${(candle.max_base_fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 150px;">Maximum Prio Fee:</strong> ${(candle.max_prio_fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 150px;">Average Payment:</strong> ${(candle.avg_payment).toFixed(8)} ETH<br>
                    <strong style="display: inline-block; width: 150px;">Average Payout:</strong> ${(candle.avg_payout).toFixed(8)} ETH<br>
                    <strong style="display: inline-block; width: 150px;">Average Base Fee:</strong> ${(candle.avg_base_fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 150px;">Average Prio Fee:</strong> ${(candle.avg_prio_fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 150px;">Average Gas Used:</strong> ${(candle.avg_gas_used / GAS_LIMIT * 100).toFixed(2)}%<br>
                </div>
                `)
                .style("left", `${tooltipLeft}px`) // It is important to put the +90: other wise the tooltip is exactly where the point is an it creates a weird effect
                .style("top", `${tooltipTop - this.heightCandlesDiv}px`)
        }

        // A function that change this tooltip when the leaves a point: just need to set opacity to 0 again
        this.mouseleaveCandles = (e, d) => {
            const barId = d3.select(e.target).attr("data-rect-id");
            const rects = d3.selectAll(".bar-group-candles")
                .selectAll("rect")
                .filter((_, gi) => gi === +barId);
            rects.classed("highlighted", false);

            this.tooltipCandles = this.tooltipCandles
                .html("")
                .style("left", `0px`)
                .style("top", `0px`)
                .style("opacity", 0)
        }

        this.clickCandles = (e, d) => {
            fetch(BLOCK_INFOS_API + `?from=${d.from_block}&to=${d.to_block}`) // fetch latest
                .then(response => response.json())
                .then(data => {
                    this.disable_append = true
                    this.setBlockInfos(data)
                    this.block_table_ui.disableAppend()
                    this.block_table_ui.setBlockInfos(data)
                })
                .catch(error => {
                    var str = `Unable to retrieve block infos ${error}.`
                    // Handle any errors that occur during the request
                    this.showError(str)
                });
        }
    }

    setupBlocksGraph = (block_history_blocks_div) => {

        this.svgBlocks = d3.select(block_history_blocks_div).append("svg")
            .attr("width", this.widthBlocksDiv)
            .attr("height", this.heightBlocksDiv)

        this.xBlocksValue = d3.scaleBand()
            .range([this.padding.left + 1, this.widthBlocksDiv - this.padding.right])

        this.yBlocksValueLower = d3.scaleLinear()
            .domain([0.0001, 20])
            .range([(this.heightBlocksDiv - this.padding.bottom), (this.heightBlocksDiv - this.padding.bottom) - (this.heightBlocksDiv - this.padding.bottom) * 1 / 4]);

        this.yBlocksValueUpper = d3.scaleLinear()
            .domain([0.0001, 20])
            .range([(this.heightBlocksDiv - this.padding.bottom) - (this.heightBlocksDiv - this.padding.bottom) * 1 / 4, this.padding.top]);

        this.yaxisBlocksValue = this.svgBlocks.append("g")
            .attr("transform", `translate(${this.padding.left}, 0)`)
            .call(d3.axisLeft(this.yBlocksValueUpper).ticks(1))
            .call(g => g.select(".domain").remove());

        this.xBlocksGas = d3.scaleLinear()
            .range([this.padding.left, this.widthBlocksDiv - this.padding.right])

        this.yBlocksGas = d3.scaleLinear()
            .domain([1, 50])
            .range([this.heightBlocksDiv - this.padding.bottom, this.padding.top]);

        this.yaxisBlocksGas = this.svgBlocks.append("g")
            .attr("transform", `translate(${this.widthBlocksDiv - this.padding.right}, 0)`)
            .call(d3.axisRight(this.yBlocksGas).ticks(1));

        // Y label
        this.ylabelBlocksValue = this.svgBlocks.append('text')
            .attr('text-anchor', 'middle')
            .attr('transform', 'translate(12,' + (this.heightBlocksDiv - this.padding.bottom + this.padding.top) / 2 + ')rotate(-90)')
            .style('font-family', 'Courier,Courier New,slab-serif')
            .style('font-size', 12)
            .style("font-weight", "bold")
            .style('fill', '#d3d3d3')
            .text('Value');

        this.ylabelBlocksGas = this.svgBlocks.append('text')
            .attr('text-anchor', 'middle')
            .attr('transform', `translate(${this.widthBlocksDiv}, ${(this.heightBlocksDiv - this.padding.bottom + this.padding.top) / 2}) rotate(-90)`)
            .style('font-family', 'Courier, Courier New, slab-serif')
            .style('font-size', 12)
            .style('font-weight', 'bold')
            .style('fill', '#d3d3d3')
            .text('Fee');

        const axisLineStyle = window.getComputedStyle(this.yaxisCandlesValue.select(".domain").node());

        this.leftLineBlocks = this.svgBlocks.append("line")
            .attr("x1", this.padding.left)
            .attr("y1", this.padding.top)
            .attr("x2", this.padding.left)
            .attr("y2", this.heightBlocksDiv - this.padding.bottom)
            .style("stroke-width", axisLineStyle.getPropertyValue("stroke-width"))
            .style("stroke", axisLineStyle.getPropertyValue("stroke"));

        this.hline1Blocks = this.svgBlocks.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthBlocksDiv - this.padding.right)
            .attr('y1', this.padding.top)
            .attr('y2', this.padding.top)
            .style("stroke-width", axisLineStyle.getPropertyValue("stroke-width"))
            .style("stroke", axisLineStyle.getPropertyValue("stroke"));

        this.hline2Blocks = this.svgBlocks.append('line')
            .attr('x1', this.padding.left)
            .attr('x2', this.widthBlocksDiv - this.padding.right)
            .attr('y1', this.heightBlocksDiv - this.padding.bottom)
            .attr('y2', this.heightBlocksDiv - this.padding.bottom)
            .style("stroke-width", axisLineStyle.getPropertyValue("stroke-width"))
            .style("stroke", axisLineStyle.getPropertyValue("stroke"));
    }

    setupBlocksToolTip = (block_history_blocks_div) => {
        // Add a tooltip div. Here I define the general feature of the tooltip: stuff that do not depend on the data point.
        // Its opacity is set to 0: we don't see it by default.
        this.tooltipBlocks = d3.select(block_history_blocks_div)
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")

        // A function that change this tooltip when the user hover a point.
        // Its opacity is set to 1: we can now see it. Plus it set the text and position of tooltip depending on the datapoint (d)
        this.mouseoverBlocks = (e, d) => {
            const barId = d3.select(e.target).attr("data-rect-id");
            const rects = d3.selectAll(".bar-group-blocks")
                .selectAll("rect")
                .filter((_, gi) => gi === +barId);
            rects.classed("highlighted", true);

            this.tooltipBlocks = this.tooltipBlocks
                .style("opacity", 1)
        }

        this.mousemoveBlocks = (e, block) => {
            const [x, y] = d3.pointer(e);

            // Calculate the tooltip position relative to the mouse cursor
            const tooltipLeft = x + 10; // Add an offset to adjust the position
            const tooltipTop = y + 10; // Add an offset to adjust the position

            var validator = block.validator
            if (validator === "") {
                validator = shortAddress(block.fee_recipient)
            }
            var builder = block.builder
            if (builder === "") {
                if (block.coinbase !== block.fee_recipient) {
                    builder = shortAddress(block.coinbase)
                } else {
                    builder = BUILDER_UNKNOWN
                        .replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/"/g, "&quot;")
                        .replace(/'/g, "&#039;");
                }
            }
            var payout = "-"
            if (block.payout !== 0) {
                payout = block.payout.toFixed(8) + " ETH"
            }
            var alimony = "-"
            if (block.alimony !== 0) {
                alimony = block.alimony.toFixed(8) + " ETH"
            }
            var payback = "-"
            if (block.payback !== 0) {
                payback = block.payback.toFixed(8) + " ETH"
            }
            var offset = "-"
            if (block.offset < 0) {
                offset = `${block.offset / 1000}s`
            }
            this.tooltipBlocks = this.tooltipBlocks
                .html(`
                <div class='tooltip-tx'>
                    <strong>Block ${block.block}</strong><br><br>
                    <strong style="display: inline-block; width: 100px;">Base Fee:</strong> ${(block.base_fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Prio Fee:</strong> ${(block.prio_fee * 1e9).toFixed(2)} Gwei<br>
                    <strong style="display: inline-block; width: 100px;">Gas:</strong> ${(block.gas_used / GAS_LIMIT * 100).toFixed(2)}%<br><br>
                    <strong style="display: inline-block; width: 100px;">Builder:</strong> ${builder}<br>
                    <strong style="display: inline-block; width: 100px;">Payout:</strong> ${payout}<br>
                    <strong style="display: inline-block; width: 100px;">Alimony:</strong> ${alimony}<br>
                    <strong style="display: inline-block; width: 100px;">Payback:</strong> ${payback}<br>
                    <strong style="display: inline-block; width: 100px;">Validator:</strong> ${validator}<br>
                    <strong style="display: inline-block; width: 100px;">Payment:</strong> ${block.payment.toFixed(8)} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Missed:</strong> ${block.difference.toFixed(8)} ETH<br>
                    <strong style="display: inline-block; width: 100px;">Offset:</strong> ${offset}<br>
                </div>
                `)
                .style("left", `${tooltipLeft}px`) // It is important to put the +90: other wise the tooltip is exactly where the point is an it creates a weird effect
                .style("top", `${tooltipTop - this.heightBlocksDiv}px`)
        }

        // A function that change this tooltip when the leaves a point: just need to set opacity to 0 again
        this.mouseleaveBlocks = (e, d) => {
            const barId = d3.select(e.target).attr("data-rect-id");
            const rects = d3.selectAll(".bar-group-blocks")
                .selectAll("rect")
                .filter((_, gi) => gi === +barId);
            rects.classed("highlighted", false);

            this.tooltipBlocks = this.tooltipBlocks
                .html("")
                .style("left", `0px`)
                .style("top", `0px`)
                .style("opacity", 0)
        }

        this.clickBlocks = (e, d) => {
            var pathname = window.location.pathname;
            // Remove leading slash from the pathname
            var path = pathname.slice(1);
            // Split the path by '/'
            var pathSegments = path.split('/');
            // navigate
            if (pathSegments.length >= 1) {
                var url = window.location.origin + "/data/" + d.block;
                // Navigate to the new URL
                window.location.href = url;
            }
        }
    }

    drawBlockCandles = (block_candles) => {
        const { maxValue, maxGas } = processBlockCandles(block_candles)

        let fromTo = block_candles[0].to_timestamp
        let toTo = block_candles[block_candles.length - 1].to_timestamp

        // Scale the range of the data in the x domain
        this.xCandlesValue.domain(block_candles.map(d => d.to_timestamp));
        this.xCandlesGas.domain([fromTo, toTo]);

        // Define the formatting pattern
        const formatPattern = "%Y-%m-%d %H:%M"; // Example: 2021-05-18 15:20:26
        // Create a time formatter
        const timeFormatter = d3.timeFormat(formatPattern);
        // Redraw x axis
        const totalHours = (toTo - fromTo) / 3600
        const tickSpanHours = getTickSpan(totalHours)
        const tickSpan = tickSpanHours * 3600

        var tick = truncateDay(toTo)
        var ticks = []
        while (tick >= fromTo) {
            ticks.push(tick)
            tick -= tickSpan;
        }

        if (this.xaxisCandles !== undefined) {
            this.xaxisCandles.remove();
        }
        const xaxis = d3.axisBottom(this.xCandlesValue)
            .tickValues(ticks)
            .tickFormat((d) => timeFormatter(new Date(d * 1000))) // Format tick labels using time formatter
            .tickSizeOuter(0);

        this.xaxisCandles = this.svgCandles.append("g")
            .attr("transform", `translate(0, ${this.heightCandlesDiv - this.padding.bottom})`)
            .call(xaxis);
        // redraw y axes value
        const yCandlesValueUpper = Math.ceil(maxValue * 1.05 * 2) / 2;
        this.yCandlesValue.domain([0, yCandlesValueUpper])
        if (this.yaxisCandlesValue !== undefined) {
            this.yaxisCandlesValue.remove()
        }
        this.yaxisCandlesValue = this.svgCandles.append("g")
            .attr("transform", `translate(${this.padding.left}, 0)`)
            .call(d3.axisLeft(this.yCandlesValue).tickValues([yCandlesValueUpper]));
        // redraw gas upper only if above 100
        let yCandlesGasUpper = maxGas
        if (yCandlesGasUpper > 50) {
            yCandlesGasUpper = Math.ceil(maxGas / 25) * 25
            this.yCandlesGas.domain([0, yCandlesGasUpper])

            if (this.yaxisCandlesGas !== undefined) {
                this.yaxisCandlesGas.remove()
            }
            this.yaxisCandlesGas = this.svgCandles.append("g")
                .attr("transform", `translate(${this.widthCandlesDiv - this.padding.right}, 0)`)
                .call(d3.axisRight(this.yCandlesGas).tickValues([yCandlesGasUpper]));
        }
        // Prepare the data for the stacked bar chart
        const keys = ['max_payment', 'max_payout'];
        const stack = d3.stack().keys(keys);
        const stackedData = stack(block_candles);

        if (this.candleBars !== undefined) {
            this.candleBars.remove()
        }
        // Create the stacked bars
        this.candleBars = this.svgCandles.append("g")
            .selectAll("g")
            .data(stackedData)
            .join("g")
            .attr("class", "bar-group-candles") // Set the class for each bar group
            .attr("fill", ({ key }) => getColorByKey(key))
            .selectAll("rect")
            .data(d => d)
            .join("rect")
            .attr("x", d => this.xCandlesValue(d.data.to_timestamp))
            .attr("y", d => this.yCandlesValue(d[1]))
            .attr("width", this.xCandlesValue.bandwidth() - 0.5)
            .attr("height", d => this.yCandlesValue(d[0]) - this.yCandlesValue(d[1]))
            .attr("data-rect-id", (d, i) => i)
            .style("fill-opacity", 0.6) // Adjust the opacity level here (0.0 to 1.0)
            .on("mouseover", (event, d) => {
                this.mouseoverCandles(event, d)
            })
            .on("mousemove", (event, d) => {
                this.mousemoveCandles(event, d.data);
            })
            .on("mouseleave", this.mouseleaveCandles)
            .on("click", (event, d) => {
                this.clickCandles(event, d.data);
            })

        const filteredData = block_candles.filter((d, i) => i % Math.floor(block_candles.length / 24) === 0 || i === block_candles.length - 1);

        if (this.candleBaseFeeLine !== undefined) {
            this.candleBaseFeeLine.remove()
        }
        // Draw the line
        this.candleBaseFeeLine = this.svgCandles.append("path")
            .datum(filteredData)
            .attr("fill", "none")
            .attr("stroke", "#d3d3d3")
            .attr("stroke-width", 2)
            //.attr("stroke-dasharray", "3 3") // Set the dash pattern
            .attr("opacity", 0.9) // Set the opacity value
            .attr("d", d3.line()
                .x(d => this.xCandlesGas(d.to_timestamp))
                .y(d => this.yCandlesGas(d.avg_base_fee * 1e9))
                .curve(d3.curveCatmullRom)
            );

        if (this.candlePriorityFeeLine !== undefined) {
            this.candlePriorityFeeLine.remove()
        }
        // Draw the line
        this.candlePriorityFeeLine = this.svgCandles.append("path")
            .datum(filteredData)
            .attr("fill", "none")
            .attr("stroke", "#eee8a9")
            .attr("stroke-width", 1)
            //.attr("stroke-dasharray", "3 3") // Set the dash pattern
            .attr("opacity", 0.9) // Set the opacity value
            .attr("d", d3.line()
                .x(d => this.xCandlesGas(d.to_timestamp))
                .y(d => this.yCandlesGas(d.avg_base_fee * 1e9 + d.avg_prio_fee * 1e9))
                .curve(d3.curveCatmullRom)
            );
    }

    drawBlockInfos = (block_infos) => {
        const { minBlock, maxBlock, minValue, maxValue, maxGas, medianValue } = processBlockInfos(block_infos)

        // Scale the range of the data in the x domain
        this.xBlocksValue.domain(block_infos.map(d => d.block));
        this.xBlocksGas.domain([minBlock, maxBlock]);
        // calc x axis ticks
        const tickSpan = 50
        var ticks = []
        var tick = maxBlock
        while (tick >= minBlock) {
            ticks.push(tick)
            tick -= tickSpan;
        }
        ticks.push(minBlock)
        // redraw x axis
        if (this.xaxisBlocks !== undefined) {
            this.xaxisBlocks.remove()
        }
        const xaxis = d3.axisBottom(this.xBlocksValue).tickValues(ticks).tickSizeOuter(0)
        this.xaxisBlocks = this.svgBlocks.append("g")
            .attr("transform", `translate(0, ${this.heightBlocksDiv - this.padding.bottom})`)
            .call(xaxis);
        // redraw y axis value
        this.adjustYValueAxis(medianValue, minValue, maxValue)
        // Prepare the data for the stacked bar chart
        const keys = ['payment', 'difference_abs', 'payout_abs', 'payback', 'alimony'];
        const stack = d3.stack().keys(keys);
        const stackedData = stack(block_infos);
        // Create the stacked bars
        if (this.blockBars !== undefined) {
            this.blockBars.remove()
        }
        this.blockBars = this.svgBlocks.append("g")
            .selectAll("g")
            .data(stackedData)
            .join("g")
            .attr("class", "bar-group-blocks") // Set the class for each bar group
            .attr("fill", ({ key }) => getColorByKey(key))
            .selectAll("rect")
            .data(d => d)
            .join("rect")
            .attr("x", d => this.xBlocksValue(d.data.block))
            .attr("y", d => this.scaleYValue(d[1]))
            .attr("width", this.xBlocksValue.bandwidth() - 0.5)
            .attr("height", d => this.scaleYValue(d[0]) - this.scaleYValue(d[1]))
            .attr("data-rect-id", (d, i) => i)
            .style("fill-opacity", 0.6) // Adjust the opacity level here (0.0 to 1.0)
            .on("mouseover", this.mouseoverBlocks)
            .on("mousemove", (event, d) => {
                this.mousemoveBlocks(event, d.data);
            })
            .on("mouseleave", this.mouseleaveBlocks)
            .on("click", (event, d) => {
                this.clickBlocks(event, d.data);
            })

        const filteredData = block_infos.filter((d, i) => d.block % BLOCK_GAS_MOD === 0 || i === block_infos.length - 1 || i === 0);
        const maxGasValue = filteredData.reduce((max, d) => {
            return Math.max(max, d.base_fee * 1e9 + d.prio_fee * 1e9);
        }, 0);
        // redraw gas upper only if above 100
        let yBlocksGasUpper = maxGasValue
        if (yBlocksGasUpper > 50) {
            yBlocksGasUpper = Math.ceil(maxGasValue / 25) * 25;
            this.yBlocksGas.domain([0, yBlocksGasUpper])

            if (this.yaxisBlocksGas !== undefined) {
                this.yaxisBlocksGas.remove()
            }
            this.yaxisBlocksGas = this.svgBlocks.append("g")
                .attr("transform", `translate(${this.widthBlocksDiv - this.padding.right}, 0)`)
                .call(d3.axisRight(this.yBlocksGas).tickValues([yBlocksGasUpper]));
        }
        // Draw the line
        if (this.blockBaseFeeLine !== undefined) {
            this.blockBaseFeeLine.remove()
        }
        this.blockBaseFeeLine = this.svgBlocks.append("path")
            .datum(filteredData)
            .attr("fill", "none")
            .attr("stroke", "#d3d3d3")
            .attr("stroke-width", 2)
            //.attr("stroke-dasharray", "3 3") // Set the dash pattern
            .attr("opacity", 0.9) // Set the opacity value
            .attr("d", d3.line()
                .x(d => this.xBlocksGas(d.block))
                .y(d => this.yBlocksGas(d.base_fee * 1e9))
                .curve(d3.curveCatmullRom)
            );

        // Draw the line
        if (this.blockPriorityFeeLine !== undefined) {
            this.blockPriorityFeeLine.remove()
        }
        this.blockPriorityFeeLine = this.svgBlocks.append("path")
            .datum(filteredData)
            .attr("fill", "none")
            .attr("stroke", "#eee8a9")
            .attr("stroke-width", 1)
            //.attr("stroke-dasharray", "3 3") // Set the dash pattern
            .attr("opacity", 0.9) // Set the opacity value
            .attr("d", d3.line()
                .x(d => this.xBlocksGas(d.block))
                .y(d => this.yBlocksGas(d.base_fee * 1e9 + d.prio_fee * 1e9))
                .curve(d3.curveCatmullRom)
            );
    }

    adjustYValueAxis = (median, min, max) => {
        // lower part of axis
        this.yBlocksValueLower.domain([0, median])
        // upper part of axis
        const yBlocksValueUpper = Math.ceil(max * 1.05 * 5) / 5;
        this.yBlocksValueUpper.domain([median, yBlocksValueUpper])
        // adjust axis labeling
        if (this.yaxisBlocksValue !== undefined) {
            this.yaxisBlocksValue.remove()
        }
        this.yaxisBlocksValue = this.svgBlocks.append("g")
            .attr("transform", `translate(${this.padding.left}, 0)`)
            .call(d3.axisLeft(this.yBlocksValueUpper).tickValues([yBlocksValueUpper]))
            .call(g => g.select(".domain").remove());
        // set reference for draw
        this.medianValue = median
    }

    scaleYValue = (y) => {
        if (y > this.medianValue) {
            return this.yBlocksValueUpper(y)
        } else {
            return this.yBlocksValueLower(y)
        }
    }
}

function processBlockCandles(block_candles) {
    let maxValue = -Infinity;
    let maxGas = -Infinity;

    for (const candle of block_candles) {
        const v = candle.max_payment + candle.max_payout
        const g = candle.avg_base_fee * 1e9 + candle.avg_prio_fee * 1e9;

        if (v > maxValue) {
            maxValue = v;
        }

        if (g > maxGas) {
            maxGas = g;
        }
    }

    return { maxValue, maxGas };
}

function processBlockInfos(block_infos) {
    let minBlock = Infinity;
    let maxBlock = -Infinity;
    let minValue = Infinity;
    let maxValue = -Infinity;
    let maxGas = -Infinity;
    let vs = []
    for (const info of block_infos) {
        info.burned = info.base_fee / 1e18 * info.gas_used
        if (info.payout < 0) {
            info.payout_abs = 0
        } else {
            info.payout_abs = info.payout
        }
        if (info.difference < 0) {
            info.difference_abs = 0
        } else {
            info.difference_abs = info.difference
        }
        const block = info.block;
        const v = info.payment + info.payout_abs + info.alimony + info.difference_abs + info.payback;
        const g = info.base_fee * 1e9 + info.prio_fee * 1e9;

        if (block < minBlock) {
            minBlock = block;
        }

        if (block > maxBlock) {
            maxBlock = block;
        }

        if (v > maxValue) {
            maxValue = v;
        }
        if (v < minValue) {
            minValue = v
        }
        vs.push(v)

        if (g > maxGas) {
            maxGas = g;
        }
    }

    var medianValue = calculateMedian(vs)

    return { minBlock, maxBlock, minValue, maxValue, maxGas, medianValue };
}

function getColorByKey(key) {
    const colorMap = new Map([
        ['burned', '#ff697c'],
        ['payment', '#26a6ed'],
        ['avg_payment', '#26a6ed'],
        ['max_payment', '#26a6ed'],
        ['difference', '#e59c23'],
        ['difference_abs', '#e59c23'],
        ['payback', '#4b2caf'],
        ['alimony', '#FFFF00'],
        ['payout', '#00A36C'],
        ['payout_abs', '#00A36C'],
        ['avg_payout', '#00A36C'],
        ['max_payout', '#00A36C'],
    ]);

    return colorMap.get(key);
}

function getTickSpan(totalHours) {
    let timeSpan;

    switch (true) {
        case (totalHours > 168): // More than 1 week (168 hours)
            timeSpan = 48
            break;
        case (totalHours > 24): // More than 1 week (168 hours)
            timeSpan = 24
            break;
        default: // Less than or equal to 24 hours
            timeSpan = 12
            break;
    }

    return timeSpan;
}

function truncateDay(timestamp) {
    const date = new Date(timestamp * 1000);
    // Set hours, minutes, seconds, and milliseconds to zero
    date.setHours(0, 0, 0, 0);
    // Convert back to Unix timestamp
    return Math.floor(date.getTime() / 1000);
}

function calculateMedian(list) {
    // Sort the list in ascending order
    const sortedList = list.slice().sort((a, b) => a - b);

    const n = sortedList.length;
    const middleIndex = Math.floor(n / 1.1);

    if (n % 2 === 0) {
        // Even number of elements
        const median = (sortedList[middleIndex - 1] + sortedList[middleIndex]) / 2;
        return median;
    } else {
        // Odd number of elements
        const median = sortedList[middleIndex];
        return median;
    }
}

function generateBlockCandles() {
    let timestamp = 1604407928;

    const date = new Date(timestamp * 1000);

    // Truncate to the nearest hour
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    // Convert back to Unix timestamp
    var truncatedTimestamp = Math.floor(date.getTime() / 1000);

    const data = [];

    for (let i = 1; i <= 168; i++) {
        const item = {
            blocks: 300,
            payment: +(Math.random() * 0.5),
            payout: +(Math.random() * 0.5),
            payback: +(Math.random() * 0.01),
            alimony: +(Math.random() * 0.5),
            difference: +(Math.random() * 0.5),
            base_fee: Math.floor(Math.random() * (40000000000 - 35000000000) + 10000000000),
            priority_fee: Math.floor(Math.random() * (2000000000 - 100000000) + 100000000),
            from: truncatedTimestamp += 3600,
            to: truncatedTimestamp + 3600
        };
        data.push(item);
    }
    return data;
}

function generateBlockInfos() {
    let block = 17285996;
    const block_hash = "0x685d2196188069f6ac352467b603974751871338615923c4b3476578af7f8b14";
    const fee_recipient = "0x388c818ca8b9251b393131c08a736a67ccb19297";
    const coinbase = "0x95222290dd7278aa3ddd389cc1e1d165cc4bafe5";
    let timestamp = 1684407928;

    const builders = ['beaverbuild', 'builder0x69', 'payload', 'Flashbots'];
    const validators = ['Lido', 'Kraken', 'Coinbase', 'Binance'];

    const data = [];

    for (let i = 1; i <= 300; i++) {
        const item = {
            slot: i,
            block: block++,
            block_hash: block_hash,
            builder: builders[Math.floor(Math.random() * builders.length)],
            validator: validators[Math.floor(Math.random() * validators.length)],
            fee_recipient: fee_recipient,
            coinbase: coinbase,
            payment: +(Math.random() * 0.5),
            payout: +(Math.random() * 0.5),
            payback: +(Math.random() * 0.01),
            alimony: +(Math.random() * 0.5),
            difference: +(Math.random() * 0.5),
            base_fee: Math.floor(Math.random() * (40000000000 - 35000000000) + 10000000000),
            priority_fee: Math.floor(Math.random() * (2000000000 - 100000000) + 100000000),
            gas_used: Math.floor(Math.random() * 56000000),
            timestamp: timestamp += 12
        };
        data.push(item);
    }
    return data;
}